var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6245 11.1083C21.6245 5.29782 16.9205 0.582031 11.1245 0.582031C5.32851 0.582031 0.624512 5.29782 0.624512 11.1083C0.624512 16.2031 4.23651 20.4452 9.02451 21.4241V14.2662H6.92451V11.1083H9.02451V8.47677C9.02451 6.44519 10.673 4.79256 12.6995 4.79256H15.3245V7.95045H13.2245C12.647 7.95045 12.1745 8.42414 12.1745 9.00308V11.1083H15.3245V14.2662H12.1745V21.582C17.477 21.0557 21.6245 16.5715 21.6245 11.1083Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.797f5454f00daf9074f3b4d6f1bea421.svg";
export { ForwardRef as ReactComponent };